module.exports = __webpack_public_path__ + "img/couche_tard.a3bad36e.png";